module.exports = __webpack_public_path__ + "static/media/Partner7.4c3057dc.webp";